//mui
import {Theme} from '@mui/material';

export const MuiLinearProgress = {
	styleOverrides: {
		root: ({theme}: {theme: Theme}) => ({
			height: 8,
			borderRadius: 'var(--default--border-radius)',
			backgroundColor: theme.palette.neutral100,

			' .MuiLinearProgress-bar': {
				borderRadius: 'var(--default--border-radius)',
				backgroundColor: theme.palette.primary500,
			},
		}),
	},
};
